import { useMember } from '../../../../contexts/widgets';
import { useExperimentalCascadingSettings } from '../../Settings/hooks';
import settingsParams from '../../settingsParams';
import stylesParams from '../../stylesParams';

export const useBadgesRenderer = () => {
  const cascadingSettings = useExperimentalCascadingSettings();
  const { badges } = useMember();

  const showBadgesSection = cascadingSettings.get(
    settingsParams.showBadgesSection,
    stylesParams.showBadgesSection,
  );
  const hasBadges = badges.length > 0;

  return { shouldRenderBadges: showBadgesSection && hasBadges };
};
